import type { CaseStudy } from "./types";

const cs: CaseStudy = {
  slug: "remote-ops",
  founder: "David & Léa Mensah",
  company: "Atlas Studio",
  city: "Remote",
  country: "EMEA",
  pillar: "fractional",
  outcomeShort: {
    en: "Built a 12-person ops engine across 4 countries",
    fr: "Une équipe ops de 12 personnes sur 4 pays",
  },
  title: {
    en: "Atlas Studio built a remote ops engine across 4 emerging markets",
    fr: "Atlas Studio a construit une machine ops remote sur 4 marchés émergents",
  },
  subtitle: {
    en: "A fractional COO turned chaos into a documented operating system.",
    fr: "Un COO temps partagé a transformé le chaos en système d'exploitation documenté.",
  },
  body: {
    en: {
      context: "David and Léa were running a profitable creative agency from Lisbon with contractors in Lagos, Tunis, Cairo and Bogotá — and burning out from coordination overhead.",
      challenge: "No documented processes, payroll spread across 4 currencies, conflicting time zones, and zero handoff hygiene. Founders spent 60% of their week on ops.",
      approach: "A fractional COO joined 3 days/week for 4 months. Implemented Notion as the single source of truth, switched contractor payments to Wise + Deel, and built a weekly ops review cadence.",
      outcome: "Founder ops time dropped from 60% to 15%. Team grew from 6 to 12 with no drop in margin. Now run a 9-person Lagos hub independently.",
      quote: "We didn't need to hire a COO full-time. We needed someone senior to set the system, then leave us with the keys.",
      quoteAuthor: "Léa Mensah · Co-founder, Atlas Studio",
    },
    fr: {
      context: "David et Léa géraient une agence créative rentable depuis Lisbonne avec des freelances à Lagos, Tunis, Le Caire et Bogotá — et brûlaient d'épuisement à force de coordination.",
      challenge: "Aucun process documenté, paie répartie sur 4 devises, fuseaux horaires conflictuels, et zéro hygiène de handoff. Les fondateurs passaient 60 % de leur semaine sur les ops.",
      approach: "Un COO temps partagé a rejoint 3 jours/semaine pendant 4 mois. Notion adopté comme source de vérité unique, paiements freelances basculés sur Wise + Deel, et cadence ops hebdo instaurée.",
      outcome: "Temps ops fondateurs passé de 60 % à 15 %. Équipe passée de 6 à 12 sans perte de marge. Hub Lagos de 9 personnes désormais opéré en autonomie.",
      quote: "On n'avait pas besoin de recruter un COO temps plein. On avait besoin de quelqu'un de senior pour poser le système, puis nous laisser les clés.",
      quoteAuthor: "Léa Mensah · Co-fondatrice, Atlas Studio",
    },
  },
};
export default cs;
